<template>
  <div>
    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-dark">
        <!-- Insert Image Here -->
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto"></div>
          <div class="col-lg-6 order-lg-1">
            <div class="pl-0">
              <h4 class="display-3 text-white">Affiliates</h4>
              <p class="text-white">
                Learn about our partner churches and how you can support their ministries.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 13. New Horizon Christian Church -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">New Horizon Christian Church</h2>
            <h5>Year Affiliated: 2011</h5>

            <p class="lead">
              The church started to hold its first worship service on March 13, 2011 with
              brothers, sisters, cousins & grandchildren worshiping together in our
              private compound. The news spread out to the community and surprisingly
              other Christians came and joined us in serving the Lord in the preceding
              Sundays. Because we grew in numbers, we made the garage of my son’s truck as
              our venue and slowly we developed it, next is history. As a young church,
              NHBC felt it was time to be legally recognized and to gain identity among
              the other Baptist Churches in the city. So, we’ve decided to invite Pastor
              Joel Idurot of One Body Christian Ministries of Sta. Ana, Manila for a visit
              and to assist the church in our intention to affiliate with Southern Baptist
              of the Philippines. Pastor Idurot came over and found the church qualified
              for affiliation. And in December of 2011, the church was officially approved
              for affiliation with OBCM.
            </p>

            <img
              v-lazy="'img/affiliates/new-horizon.jpeg'"
              class="img-fluid rounded shadow mt-4"
              alt="New Horizon Christian Church"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 14. OBCM Daet, Camarines Norte -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">OBCM Daet, Camarines Norte</h2>
            <h5>Year Affiliated: 2014</h5>

            <p class="lead">
              Since its inception, this church had its own sets of need typical with other
              emerging small community churches and ministry. They need a strong network
              of community churches to encourage them in the area of leadership and
              training to equip them in the multifaceted challenges that confront them in
              order to sustain, develop, and grow to maturity. This process will bring
              them to be able to plant new and healthy churches with the same DNA sets.
              When we first visited this church under the able leadership of Pastor Henry
              Hermocilla and his family, we immediately identified several things
              physically needing attention like improvements in their building structure,
              an accessible and potable water supply, and other logistics. The OBCM
              Association Christian Builder was asked and later mobilized to work on the
              physical aspect of the building, floors, raised roof structure, restrooms,
              and install a deep well within the church premises. OBCM Sta. Ana sponsored
              delegates and representatives to attend gatherings, trainings, and
              associational meetings. We also sent representatives and workers to Daet
              from Manila to conduct VBS, youth training and gathering. Presently, OBCM
              Daet is a resilient church with a different set of challenges of growing and
              reaching out to the tribes and other barrios of Bicol. I am confident that,
              “He who began the good work in you is always faithful to complete in you
              until the day of Christ.” Philippians 1:6
            </p>

            <img
              v-lazy="'img/affiliates/obcm-daet.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="OBCM Daet, Camarines Norte"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 15. Temple Baptist Church - Aritao, Nueva Vizcaya -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Temple Baptist Church - Aritao, Nueva Vizcaya</h2>
            <h5>Year Affiliated: 2019</h5>

            <p class="lead">
              Temple Baptist Church is a church God planted among the Ilocanos located 265
              km. North East of Luzon. The De Guzman Family was used as God’s man of peace
              in Aritao - Sister Flor De Guzman facilitated the purchase of a lot and
              building to construct the worship center. Travelling by bus in the 80’s is a
              challenge to missionaries doing the initial mass evangelism and missions.
              The great earthquake which struck in the early 90’s isolated the province
              due to the damages inflicted on the road network leading to the north. The
              many issues within the church and in leadership were the various testing of
              the church’s ability to thrive and grow. Extending the ministry at Gawad
              Kalinga village through Brother Alrey Baysa and in Barangay Kirang, Temple
              Baptist Church expanded further its ministry as well as starting a school,
              the Baptist Academy of Aritao, with their own building and a playground and
              an annex in Kumon, Aritao for almost 2 decades now. The school ministry
              involves sharing the Gospel to students with its Christian Values and Bible
              centered curriculum. Cooperative mission is alive in Aritao. A network of
              like minded OBCM churches helped homegrown leader like Brother Alrey Baysa
              and Brother Kevin Tabajonda be complimented by OBCM Association-based
              pastors to continue ministering to the Ilocanos.
            </p>

            <img
              v-lazy="'img/affiliates/temple-baptist.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="Temple Baptist Church - Aritao, Nueva Vizcaya"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 16. Gateway Christian Faith Baptist Church -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Gateway Christian Faith Baptist Church</h2>
            <h5>Year Affiliated: 2019</h5>

            <p class="lead">
              This church was established on August 7, 2016, with an initial group of
              thirty (30) members composed of 12 families along with several young people.
              At present, GCFBC continues to grow in number and in faith as a church under
              the leadership of Ptr. Joselito Galicia. As a Southern Baptist Church, in
              2019, GCFBC expressed its desire to join the OBCM Association in order to be
              part of a group that shares the same faith and can work together to
              strengthen their spiritual journey.
            </p>

            <img
              v-lazy="'img/affiliates/gateway.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="Gateway Christian Faith Baptist Church"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 17. Redemption in Christ Fellowship -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Redemption in Christ Fellowship</h2>
            <h5>Year Affiliated: 2019</h5>

            <p class="lead">
              Redemption in Christ Fellowship (RCF) is a church planted by God’s grace and
              sustained for His glory. In January 2018, after a season of brokenness, the
              Lord, in His mercy, reestablished the church through prayer, repentance, and
              the help of faithful servants. Our name is anchored in Ephesians 1:7: “In
              Him we have redemption through His blood, the forgiveness of our trespasses,
              according to the riches of His grace.” We are a people redeemed by Christ
              alone, not because of our worth, but because of His abundant mercy and love.
              Our desire is to make much of Christ—proclaiming the Gospel, making
              disciples, and walking humbly in obedience to His Word.
            </p>

            <img
              v-lazy="'img/affiliates/rcf.jpeg'"
              class="img-fluid rounded shadow mt-4"
              alt="Redemption in Christ Fellowship"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 18. Redeemer Christian Church Manila -->
    <section class="section bg-secondary">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Redeemer Christian Church Manila</h2>
            <h5>Year Affiliated: 2020</h5>

            <p class="lead">
              Redeemer Christian Church Manila (RCCM), a Southern Baptist church, was
              planted in July 2020—during a time when much of Manila was under quarantine
              due to the pandemic. From the beginning, the church’s mission has been to
              clearly proclaim the Gospel to the city. Redeemer was established amid a
              season when various distorted versions of the Christian message were
              spreading, and its founding vision was to be a church rooted in the truth of
              Scripture, with all its ministries centered on the true, biblical Gospel.
              Now entering its fifth year, RCCM remains steadfast in its calling—reaching
              out to young professionals, young couples, and families across Manila with
              the lifetransforming message of God’s grace through Jesus Christ. In 2020,
              Redeemer applied for membership with One Body Christian Ministries (OBCM),
              an association of Southern Baptist churches. That December, we were
              officially welcomed and presented with our certificate of membership.
              Joining OBCM aligned with our desire to be part of a community of
              like-minded churches committed to faithful preaching, Gospel-centered
              ministry, and the planting of healthy, biblical churches.
            </p>

            <img
              v-lazy="'img/affiliates/rccm.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="Redeemer Christian Church Manila"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- 19. Emmanuel Christ’s Disciple Church -->
    <section class="section section-shaped section-lg my-0">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-lg-12">
            <h2 class="display-3">Emmanuel Christ’s Disciple Church</h2>
            <h5>Year Affiliated: 2023</h5>

            <p class="lead">
              Emmanuel Christ’s Disciple Church (ECDC) was officially established as an
              independent congregation on March 4, 1990. It initially began as a mission
              area under the spiritual guidance of Pinamalayan Christian Baptist Church
              (PCBC). However, due to leadership challenges within PCBC, Del Razon
              Christian Baptist Church formally organized and became an autonomous church
              on the same date. The church’s first lead pastor was Rev. Danilo Duque, who
              shepherded the congregation from 1990 until 1994. He was succeeded by Pastor
              Arnel Palacio, who served from 1994 to 1996. During this period, the church
              encountered leadership difficulties that required a reorganization to ensure
              its stability and continued growth. In January 1997, Bro. Oscar C. Linga
              assumed leadership and management of Emmanuel Covenant Baptist Church
              (ECBC). Under his steadfast guidance, the church stabilized and experienced
              continual growth, with his leadership extending to the present day. ECBC was
              initially affiliated with the Mindoro Southern Baptist Churches Fellowship
              (MSBCF). However, concerns arose regarding certain practices within MSBCF,
              specifically the allowance of female leaders to preach, manage the church,
              and participate in monthly pulpit rotation schedules. Upholding the church’s
              Statement of Faith—which affirms that such roles are not to be performed by
              women—I formally declared the separation of ECBC from MSBCF during our
              monthly meetings and sent a letter for formal separation. Approximately one
              year later, we sought new affiliation through One Body Christian Ministries
              (OBCM) approaching its leaders Pastors Uziel and Joel Idurot in November
              2023. Our affiliation with One Body Christian Ministries is a covenant
              relationship designed to strengthen local churches through unity in Christ,
              shared spiritual resources, accountability, and cooperative ministry efforts
              that align with biblical teaching and advance God’s kingdom work
              collectively but without compromising local church independence.
            </p>

            <img
              v-lazy="'img/affiliates/ecdc.jpg'"
              class="img-fluid rounded shadow mt-4"
              alt="Emmanuel Christ’s Disciple Church"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "affiliates",
  components: {},
};
</script>

<style scoped>
.gcash-number {
  font-weight: bold;
  font-size: 2.5rem;
  color: #212329;
}
</style>
